module.exports = __webpack_public_path__ + "media/books/Books-WhoItsFor-Parents-38f8213b.jpg";